// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message

export const SM = 'SM';
export const MD = 'MD';
export const LG = 'LG';